import { CheckboxWithoutLabel, CheckedStatus } from 'Components/Checkbox/CheckboxWithoutLabel';
import { RiskRating } from 'Models/RiskRating';

import styles from './DueDiligenceAssessmentCheckboxRow.module.css';

export interface RiskRatingCheckedStatuses {
    low: CheckedStatus;
    lowMod: CheckedStatus;
    mod: CheckedStatus;
    modHigh: CheckedStatus;
    high: CheckedStatus;
}

export interface DueDiligenceAssessmentCheckboxRowProps extends RiskRatingCheckedStatuses {
    onToggled: (isChecked: boolean, riskRating: RiskRating) => void;
}

/** Renders one checkbox per `RiskRating`. */
export const DueDiligenceAssessmentCheckboxRow = (props: DueDiligenceAssessmentCheckboxRowProps) => {
    return (
        <>
            <div className={styles.checkbox}>
                <CheckboxWithoutLabel onToggled={(isChecked) => props.onToggled(isChecked, RiskRating.LOW)} status={props.low} />
            </div>
            <div className={styles.checkbox}>
                <CheckboxWithoutLabel onToggled={(isChecked) => props.onToggled(isChecked, RiskRating.LOW_MODERATE)} status={props.lowMod} />
            </div>
            <div className={styles.checkbox}>
                <CheckboxWithoutLabel onToggled={(isChecked) => props.onToggled(isChecked, RiskRating.MODERATE)} status={props.mod} />
            </div>
            <div className={styles.checkbox}>
                <CheckboxWithoutLabel onToggled={(isChecked) => props.onToggled(isChecked, RiskRating.MODERATE_HIGH)} status={props.modHigh} />
            </div>
            <div className={styles.checkbox}>
                <CheckboxWithoutLabel onToggled={(isChecked) => props.onToggled(isChecked, RiskRating.HIGH)} status={props.high} />
            </div>
        </>
    );
};
